import { Client } from "@/clients/client";

export class ManageMemberService {
  constructor(private client: Client) {}

  public async getAllMembers(params: {
    search?: string;
    company_ids?: number[];
    role?: string;
    status?: string;
    page?: number;
    size?: number;
  }): Promise<any> {
    return this.client.memberClient.getAllMembers(params);
  }

  public async globalInviteMember(form: { email: string; role: string; company_ids: number[] }): Promise<any> {
    return this.client.memberClient.globalInviteMember(form);
  }

  public async checkMemberEmail(email: string): Promise<any> {
    return this.client.memberClient.checkMemberEmail(email);
  }

  public async globalUpdateMember(
    memberId: number,
    form: {
      name?: string;
      email?: string;
      role?: string;
      status?: string;
      profileImageUrl?: string;
      company_ids?: number[];
    }
  ): Promise<any> {
    return this.client.memberClient.globalUpdateMember(memberId, form);
  }

  public async getCompanyMembers(
    companyId: number,
    params?: { search?: string; role?: string; status?: string; page?: number; size?: number }
  ): Promise<any> {
    return this.client.memberClient.getCompanyMembers(companyId, params);
  }

  public async removeMemberFromCompany(companyId: number, memberId: number): Promise<any> {
    return this.client.memberClient.removeMemberFromCompany(companyId, memberId);
  }
}
